module.exports = __webpack_public_path__ + "static/media/facebookGray.4638ab80.svg";